import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getProjects } from '../services/projectService';
import type { ProjectListFilters, ProjectListItem } from '../types/project';

const EMPTY_FILTERS: ProjectListFilters = {};

export function useProjects() {
  return usePaginatedMasterData<ProjectListItem, ProjectListFilters>({
    getId: item => item.projectId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load projects.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getProjects({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
